import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

export const PhoneFormat = ({ inputRef, onChange, name, ...rest }) => {
    return (
        <NumberFormat
            {...rest}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            format="###-###-####"
        />
    );
};

PhoneFormat.propTypes = {
    inputRef: PropTypes.any,
    onChange: PropTypes.func,
    name: PropTypes.string,
    rest: PropTypes.object,
};

export const IDFormat = ({ inputRef, onChange, name, ...rest }) => {
    return (
        <NumberFormat
            {...rest}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            format="#-#####-###-###-#"
        />
    );
};

IDFormat.propTypes = {
    inputRef: PropTypes.any,
    onChange: PropTypes.func,
    name: PropTypes.string,
    rest: PropTypes.object,
};

export const TimeFormat = ({ inputRef, onChange, name, ...rest }) => {
    return (
        <NumberFormat
            {...rest}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            format="##:##"
        />
    );
};

TimeFormat.propTypes = {
    inputRef: PropTypes.any,
    onChange: PropTypes.func,
    name: PropTypes.string,
    rest: PropTypes.object,
};
